import { GetterTree } from "vuex";
import { ICompanyState } from "@/store/modules/company/state";
import { Company } from "@/types";

import { IDataProvider, IRootState } from "@/store";

export enum CompanyGetters {
  GET_ALL = "GET_ALL_COMPANY",
  GET_CURRENT = "GET_CURRENT_COMPANY",
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_COMPANY",
  GET_ACTIVE_COMPANY_ID = "GET_ACTIVE_COMPANY_ID",
}

export const getters: GetterTree<ICompanyState, IRootState> = {
  [CompanyGetters.GET_ALL](state): Company[] | null {
    return state.companies;
  },
  [CompanyGetters.GET_CURRENT](state): Company | null {
    return state.company;
  },
  [CompanyGetters.GET_DATA_PROVIDER](state): Company[] | null {
    return state.dataProvider;
  },
  [CompanyGetters.GET_ACTIVE_COMPANY_ID](state): string | null {
    return state.companyIdActive;
  },
};
